import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Loadable, Table, TableHead, TableHeader, TableBody, TableRow } from '@ctct/ui-react';

import type { PriceEstimatorTableI18nKeys } from './types';

export function PriceEstimatorTable({
  isLoading,
  i18nKeys: i18n,
  planType,
  children,
}: {
  isLoading: boolean;
  i18nKeys: PriceEstimatorTableI18nKeys;
  planType: string;
  children?: ReactNode;
}) {
  const { t } = useTranslation();

  return (
    <div className="price-estimator-table wrapper-table">
      <Loadable loading={isLoading}>
        <div className="price-estimator-table">
          <Table data-qe-id="price-selector-table">
            <TableHead className="price-table-head">
              <TableRow header>
                <TableHeader scope="col" className="price-estimator-contact-col">
                  {t(i18n.listSize)}
                </TableHeader>
                <TableHeader scope="col" className="price-estimator-pricing-col">
                  {t(i18n.plans[planType] ?? i18n.unknownPlanType)}
                </TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>{children}</TableBody>
          </Table>
        </div>
      </Loadable>
    </div>
  );
}
